import Icon, {
  MessageOutlined,
  SettingOutlined,
  IdcardOutlined,
  FileDoneOutlined,
  BarChartOutlined,
  QuestionCircleOutlined,
  ScheduleOutlined,
  ToolOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { MdOutlineDashboard } from "react-icons/md";
import AppsSvgIcon from "assets/images/icons/apps.svg";
import BillingSvgIcon from "assets/images/icons/billing.svg";
import BusinessFlowSvgIcon from "assets/images/icons/businessflow.svg";
import ChannelSvgIcon from "assets/images/icons/channel.svg";
import CompanySvgIcon from "assets/images/icons/company.svg";
import MyProfileSvgIcon from "assets/images/icons/my_profile.svg";
import RolesSvgIcon from "assets/images/icons/roles.svg";
import SettingTemplateSvgIcon from "assets/images/icons/setting_template.svg";
import TagsSvgIcon from "assets/images/icons/tags.svg";
import UsersSvgIcon from "assets/images/icons/users.svg";
import AuditSvgIcon from "assets/images/icons/audit.svg";
import TemplateSvgIcon from "assets/images/icons/template.svg";
import CategorySvgIcon from "assets/images/icons/category.svg";
import ChatBotsSvgIcon from "assets/images/icons/chat-bots.svg";
import BroadcastIcon from "assets/images/icons/components/broadcast";
import TicketIcon from "assets/images/icons/components/ticket";
import DivisionIcon from "assets/images/icons/division.svg";
import OpenApiIcon from "assets/images/icons/open-api.svg";
import MeetingScheduleIcon from "assets/images/icons/meeting-schedule.svg";
import Rating1 from "assets/images/icons/rating-icons/rating-1.svg";
import Rating2 from "assets/images/icons/rating-icons/rating-2.svg";
import Rating3 from "assets/images/icons/rating-icons/rating-3.svg";
import Rating4 from "assets/images/icons/rating-icons/rating-4.svg";
import Rating5 from "assets/images/icons/rating-icons/rating-5.svg";
import ThankYouSVG from "assets/images/icons/rating-icons/thankyou.svg";
import QualityAssurance from "assets/images/icons/quality-assurance.svg";
import InboxTicketingIcon from "assets/images/icons/inbox-ticketing.svg";
import WebhookIcon from "assets/images/icons/webhook.svg";

export const AppIcon = ({ name, ...props }) => {
  switch (name) {
    case "company":
      return <MessageOutlined {...props} />;
    case "settings":
      return <SettingOutlined {...props} />;
    case "smile":
      return <Icon component={SmileSvg} {...props} />;
    case "contact":
      return <IdcardOutlined {...props} />;
    case "lead-and-task-management":
      return <FileDoneOutlined {...props} />;
    case "reports":
      return <BarChartOutlined {...props} />;
    case "blast":
      return <Icon component={BroadcastIcon} {...props} />;
    case "faqs":
      return <QuestionCircleOutlined {...props} />;
    case "meeting_management":
      return <ScheduleOutlined {...props} />;
    case "help":
      return <ToolOutlined {...props} />;
    case "quality-assurance":
      return <SolutionOutlined {...props} />;
    case "ticketing":
      return <Icon component={TicketIcon} {...props} />;
    default:
      return <MdOutlineDashboard {...props} />;
  }
};

const SmileSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
    >
      <path
        opacity=".45"
        fill="#263238"
        d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"
      ></path>
    </svg>
  );
};

AppIcon.displayName = "AppIcon";

export const LazySvgIcon = ({ name, ...props }) => {
  switch (name) {
    case "company":
      return <img src={CompanySvgIcon} {...props} />;
    case "billing":
      return <img src={BillingSvgIcon} {...props} />;
    case "settings":
      return <img src={BusinessFlowSvgIcon} {...props} />;
    case "setting_template":
      return <img src={SettingTemplateSvgIcon} {...props} />;
    case "profile":
      return <img src={MyProfileSvgIcon} {...props} />;
    case "users":
      return <img src={UsersSvgIcon} {...props} />;
    case "roles":
      return <img src={RolesSvgIcon} {...props} />;
    case "clipboard-check":
      return <img src={TagsSvgIcon} {...props} />;
    case "link":
      return <img src={ChannelSvgIcon} {...props} />;
    case "apps":
      return <img src={AppsSvgIcon} {...props} />;
    case "receipt":
      return <img src={TemplateSvgIcon} {...props} />;
    case "audits":
      return <img src={AuditSvgIcon} {...props} />;
    case "list":
      return <img src={CategorySvgIcon} {...props} />;
    case "chat-bots":
      return <img src={ChatBotsSvgIcon} {...props} />;
    case "divisions":
      return <img src={DivisionIcon} {...props} />;
    case "meeting_schedule":
      return <img src={MeetingScheduleIcon} {...props} />;
    case "open-api":
      return <img src={OpenApiIcon} {...props} />;
    case "rating-1":
      return <img src={Rating1} {...props} />;
    case "rating-2":
      return <img src={Rating2} {...props} />;
    case "rating-3":
      return <img src={Rating3} {...props} />;
    case "rating-4":
      return <img src={Rating4} {...props} />;
    case "rating-5":
      return <img src={Rating5} {...props} />;
    case "thankyou":
      return <img src={ThankYouSVG} {...props} />;
    case "quality_assurance":
      return <img src={QualityAssurance} {...props} />;
    case "ticketing":
      return <img src={InboxTicketingIcon} {...props} />;
    case "webhook":
      return <img src={WebhookIcon} {...props} />;
    default:
      return <img src={CompanySvgIcon} {...props} />;
  }
};

LazySvgIcon.displayName = "LazySvgIcon";
